//import useAuth from "../../../../hooks/useAuth";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { authUserSignal } from '../../../signals/authSignal';
import { createLogger } from '../../../utils/logger';

const logger = createLogger('RequiredAuth');

const RequiredAuth = () => {
  //const { auth } = useAuth();
  const location = useLocation();

  const user = authUserSignal.value;
  logger.debug('authUserSignal.value=', JSON.stringify(user))

  if (!user?.name) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user.mustChangePassword && location.pathname !== "/change-access-code") {
    return <Navigate to="/change-access-code" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default RequiredAuth;
